/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { useTableKeyboardNavigation as r } from "@progress/kendo-react-data-tools";
import { GridContext as l } from "../../GridClientWrapper.mjs";
import { cloneReactElement as m } from "../../utils/index.mjs";
const d = (e) => {
  const t = n.useContext(l), o = r(e.id), a = n.useCallback(
    (i) => {
      t != null && t.onContextMenu && t.onContextMenu.call(void 0, i, e.dataItem);
    },
    [t, e.dataItem]
  );
  return m(e.children, {
    onContextMenu: a,
    ...o
  });
};
export {
  d as DetailCellContainer
};
